import { useCallback } from 'react'
import {
    useEditorActionBarActions,
    useShallowEditorActionBar,
} from '../store/EditorActionBarStore'
import { useSyncInactiveContentVisibility } from './useSyncInactiveContentVisibility'
import { useSyncPTLinksVisibility } from './useSyncPTLinksVisibility'

/**
 * Returns functions for toggles and closing menu inside visibility settings popover.
 */
export const useClickMenuItem = () => {
    const { syncToLocalStorage: syncInactiveContentToLocalStorage } = useSyncInactiveContentVisibility()
    const { syncToLocalStorage: syncPTLinksToLocalStorage } = useSyncPTLinksVisibility()
    const { visibilitySettingValues } = useShallowEditorActionBar((state) => ({
        visibilitySettingValues: state.visibilitySettingValues,
    }))
    const {
        setVisibilitySettingValues,
        setIsVisibilitySettingsMenuDisplayed,
    } = useEditorActionBarActions()
    const onClickMenuItem = useCallback(
        (
            actionType: keyof typeof visibilitySettingValues,
            actionValue: boolean
        ) => {
            setVisibilitySettingValues?.({
                ...visibilitySettingValues,
                [actionType]: actionValue,
            })

            if (actionType === 'isInactiveContentVisible') {
                syncInactiveContentToLocalStorage(actionValue)
            }

            if (actionType === 'arePTLinksVisible') {
                syncPTLinksToLocalStorage(actionValue)
            }
        },
        [
            visibilitySettingValues,
            setVisibilitySettingValues,
            syncInactiveContentToLocalStorage,
            syncPTLinksToLocalStorage,
        ]
    )
    const onCloseMainMenu = useCallback(() => {
        setIsVisibilitySettingsMenuDisplayed?.(false)
    }, [setIsVisibilitySettingsMenuDisplayed])
    return {
        onClickMenuItem,
        onCloseMainMenu,
    }
}
